export default (theme) => ({
  inputAdornment: {
    marginRight: theme.spacing(3),
  },
});
